import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  ThemeProvider,
} from '@mui/material'
import ReactDOM from 'react-dom'
import { authedAxios } from '../../../utils'
import theme from '../../../styles/theme'
import { ACCOUNT_PROVIDERS } from '../../../constants'

const AccountProviderDialog = ({ open, onClose, onSubmit }) => {
  const [selectedProviderId, setSelectedProviderId] = useState(null)

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Which email/calendar provider do you use?</DialogTitle>
      <DialogContent>
        <FormControl>
          <RadioGroup
            value={selectedProviderId}
            onChange={(e) => setSelectedProviderId(Number(e.target.value))}
          >
            {ACCOUNT_PROVIDERS.map((ap) => (
              <FormControlLabel
                key={ap.id}
                value={ap.id}
                control={<Radio />}
                label={ap.name}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant={'outlined'}>
          Cancel
        </Button>
        <Button
          variant={'contained'}
          disabled={!selectedProviderId}
          onClick={() => onSubmit(selectedProviderId)}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  )
}

// I can't tell if this is really cool or really silly.
// I kind of just wanted to prove to myself that it works

export const checkForAccountProvider = () => {
  return new Promise((resolve, reject) => {
    const removeNode = () =>
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-target'))

    const onClose = () => {
      removeNode()
      reject()
    }

    const onSubmit = (accountProviderId) => {
      return authedAxios
        .put('/api/identity/account-provider', { accountProviderId })
        .then(() => {
          removeNode()
          resolve(accountProviderId)
        })
        .catch(() => {
          removeNode()
          reject()
        })
    }

    ReactDOM.render(
      <ThemeProvider theme={theme}>
        <AccountProviderDialog
          open={true}
          onClose={onClose}
          onSubmit={onSubmit}
        ></AccountProviderDialog>
      </ThemeProvider>,
      document.getElementById('modal-target')
    )
  })
}

export default AccountProviderDialog
